import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState, useMemo } from "preact/hooks"
import RangeInput from "./elements/RangeInput"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id);
    const isSelected = min !== range[0] || max !== range[1];
    const [active, setActive] = useState(isSelected);
    const facetLabel = useMemo(() => facet.field.replaceAll('.', '-').replaceAll(' ', '-'), []) ;

    const toggleActive = () => {
        setActive(prevActive => !prevActive)
    }
    
    return (
        <li class="ns-facet ns-range-facet">
            <button
                className="ns-facet__dropdown-toggle ns-w-full ns-flex ns-flex-nowrap ns-items-center ns-justify-between"
                type="button"
                data-nosto-element="facet"
                aria-controls={`ns-facet-${facetLabel}`}
                aria-label={`Expand ${facet.name} filter options`}
                aria-expanded={active}
                onClick={toggleActive}
                tabIndex="0"
            >
                <span className="ns-facet__dropdown-toggle-text">
                    {facet.name}
                </span>
                <svg class="ns-facet__dropdown-toggle-icon" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                    <path d="M56 39.671c0 0.449-0.224 0.954-0.561 1.291l-2.806 2.806c-0.337 0.337-0.786 0.561-1.291 0.561-0.449 0-0.954-0.224-1.291-0.561l-22.052-22.052-22.052 22.052c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-2.806-2.806c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l26.148-26.148c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l26.148 26.148c0.337 0.337 0.561 0.842 0.561 1.291z"></path>
                </svg>
            </button>
            <div
                class="ns-facet__dropdown"
                id={`ns-facet-${facetLabel}`}
                aria-hidden={!active}
                aria-labelledby={`ns-facet-heading-${facetLabel}`}
                role="region"
            >
                <div className="ns-facet__dropdown-inner">
                    <div class="ns-labels-container ns-flex ns-justify-between">
                        <div class="" style="width: 50%;">
                            <label for={`ns-${facet.id}-min`} class="ns-form-label">
                                Min.
                            </label>
                            <RangeInput
                                id={`ns-${facet.id}-min`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[0]}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([value, range[1]])
                                }}
                            />
                        </div>
                        <div class="" style="width: 50%;">
                            <label for={`ns-${facet.id}-max`} class="ns-form-label">
                                Max.
                            </label>
                            <RangeInput
                                id={`ns-${facet.id}-max`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[1]}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([range[0], value])
                                }}
                            />
                        </div>
                    </div>
                    <RangeSlider id={facet.id} />
                </div>
            </div>
        </li>
    )
}
